import { render, staticRenderFns } from "./FederatedDaps.vue?vue&type=template&id=273a8a26"
import script from "./FederatedDaps.vue?vue&type=script&lang=js"
export * from "./FederatedDaps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports